/**
 * **素材の一覧**（Issue #528。索引 #525）。
 *
 * 素材 ＝ **宣言の層（`layers: [{ part: 'ring' }]`）が置く絵**。2D canvas に描くだけで、
 * どこに・どの大きさで置くかは器（`stage/EffectLayer.js`）が決める。
 *
 * **テーマは素材を「名前」で参照する**ので `themes/` はこの木を import しない
 * （守ること 17 はそのまま）。**素材は three を知らない**ので守ること 11b もそのまま ——
 * three が要る絵は演出の `script` 層が `ctx.THREE` を受け取って書く。
 *
 * 足すときは `parts/<id>.js` を作って下の表に 1 行足す（`require.context` を使わないのは、
 * jest と webpack で読み方が変わるのを避けるため。`themes/index.js` と同じ）。
 */
import beam from './beam';
import card from './card';
import glow from './glow';
import ring from './ring';
import text from './text';

export const PARTS = Object.freeze([beam, card, glow, ring, text]);

const BY_ID = new Map(PARTS.map((p) => [p.id, p]));

/** 名前から引く（**知らない名前は `null`**。呼ぶ側が「その層は描かない」と決める） */
export const partOf = (id) => BY_ID.get(String(id ?? '')) ?? null;

export const PART_IDS = Object.freeze(PARTS.map((p) => p.id));
